import { useState } from "react";
import { toast } from "react-toastify";

import { getPlanEstimate, Plan } from "api/plan-change";
import { getUserFriendlyErrorMessage } from "api/UserFriendlyError";

import { PlanChangeIntention } from "../../PlanChangeIntention.type";

export function usePlanEstimate() {
  const [planChangeIntention, setPlanChangeIntention] =
    useState<PlanChangeIntention | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  async function getPlanEstimateValue({
    planId,
    plan,
    isAnnual,
  }: {
    planId: string;
    plan: Plan;
    isAnnual: boolean;
  }) {
    setIsLoading(true);

    try {
      const estimate = await getPlanEstimate({
        planId,
        ugcLibraryAddon: false,
      });
      const intention = {
        planId,
        ugcLibraryAddon: false,
        plan,
        isAnnual,
        estimate,
      };

      setPlanChangeIntention(intention);
      setShowConfirm(true);

      return intention;
    } catch (error) {
      toast.error(getUserFriendlyErrorMessage(error));
      throw error;
    } finally {
      setIsLoading(false);
    }
  }

  function goBack() {
    setShowConfirm(false);
    setPlanChangeIntention(null);
  }

  return {
    planChangeIntention,
    isLoading,
    showConfirm,
    goBack,
    getPlanEstimate: getPlanEstimateValue,
  };
}
